export default __webpack_public_path__ + "static/experienceImg3-5b80c1b54645b0f70b2a806b138f3fe7.png";